// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h6[data-v-05ac77ee] {\n  color: var(--dark-green-60, #66827f);\n  font-size: 0.88rem !important;\n  font-weight: 400;\n}\nh6 span[data-v-05ac77ee] {\n  color: var(--dark-green-100, #002e2a);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
